import { createSlice } from "@reduxjs/toolkit";

const SLICE_NAME = "categories"

const INITIAL_STATE = {
  categories: [],
}

export const categoriesSlice = createSlice({
  name: SLICE_NAME,
  initialState: INITIAL_STATE,
  reducers: {
    setCategories: (state, action) => {
      const { payload: newCategories } = action

      state.categories = newCategories
    },
  },
})

export const {
  setCategories,
} = categoriesSlice.actions

export const getCategories = (state) => state[SLICE_NAME].categories

export const getCategorySlugs = (state) => state[SLICE_NAME].categories.map((category) => category.slug)

export default categoriesSlice.reducer
